import _ from 'lodash'

class CommonOptionVM {
  // column_options?: any; // deprecated previously used for site questions
  not_visible?: boolean;
  hidden?: boolean;
  exclude_report?: boolean;
  info_id?: string;
  global_item_id?: string
  rule_set_id?: string;
  repeatable?: boolean
  minimum_repetition?: number
  maximum_repetition?: number;
  /**
   * @description Uses only inside src/modules/checklist/views/template-builder/add-edit-question/question-types/global-item.tsx to pass replace true parameter when replacing normal item with global item
   * @description (Should be changed to a new way to replace item)
   * */
  replace?: boolean

  constructor(data?: Partial<CommonOptionVM>) {
    this.repeatable = !_.isUndefined(data?.repeatable) ? data?.repeatable : undefined
    this.minimum_repetition = !_.isUndefined(data?.minimum_repetition) ? data?.minimum_repetition : undefined
    this.maximum_repetition = !_.isUndefined(data?.maximum_repetition) ? data?.maximum_repetition : undefined
    this.not_visible = !_.isUndefined(data?.not_visible) ? data?.not_visible : undefined
    this.hidden = !_.isUndefined(data?.hidden) ? data?.hidden : undefined
    this.exclude_report = !_.isUndefined(data?.exclude_report) ? data?.exclude_report : undefined
    this.rule_set_id = !_.isUndefined(data?.rule_set_id) ? data?.rule_set_id : undefined
    this.info_id = !_.isUndefined(data?.info_id) ? data?.info_id : undefined
    this.global_item_id = !_.isUndefined(data?.global_item_id) ? data?.global_item_id : undefined
    this.replace = data?.replace
  }

  validateCommonOptions() {
    const errors: any[] = []

    // Validate maximum_repetition
    if (this.maximum_repetition && this.maximum_repetition <= 0) {
      errors.push({ key: 'maximum_repetition', error_message: 'Maximum repetition must be greater than 0' })
    }

    // Validate minimum_repetition
    if (this.minimum_repetition && this.minimum_repetition < 0) {
      errors.push({ key: 'minimum_repetition', error_message: 'Minimum repetition must be 0 or greater' })
    }

    // Validate maximum is greater than minimum when both exist
    if (this.maximum_repetition && this.minimum_repetition) {
      const max = this.maximum_repetition
      const min = this.minimum_repetition
      if (max <= min) {
        errors.push({ key: 'maximum_repetition', error_message: 'Maximum repetition must be greater than minimum repetition' })
      }
    }
    // if (true) {
    //   errors.push({key: 'key_name', error_message: 'error_message'})
    // }
    return {
      is_valid: errors.length === 0,
      errors
    }
  }
}

export { CommonOptionVM }